import { useEffect, useMemo, useState } from "react";
import {
  getOS,
  isInstalled,
  shouldShowInstallPrompt,
} from "../utils/pwaTwa/detectionHelper";
import { PWA_SHOW_IN_MS } from "../constants";
import PwaModal from "./PwaModal";

const PwaInstallPrompt = () => {
  const [open, setOpen] = useState(false);

  // Compute once on mount; display-mode rarely changes at runtime.
  const os = useMemo(getOS, []);
  const installed = useMemo(isInstalled, []);

  useEffect(() => {
    // Only target Android and iOS, never desktop/other
    const isMobileTarget = os === "android" || os === "ios";
    if (!isMobileTarget) {
      setOpen(false);
      return;
    }

    // Don't show if installed (PWA or TWA)
    if (installed) {
      setOpen(false);
      return;
    }

    // Respect cooldown
    if (shouldShowInstallPrompt(PWA_SHOW_IN_MS)) {
      setOpen(true);
    }
  }, [os, installed]);

  // If user installs during session, stop showing the modal again
  useEffect(() => {
    const onAppInstalled = () => setOpen(false);
    window.addEventListener("appinstalled", onAppInstalled);
    return () => window.removeEventListener("appinstalled", onAppInstalled);
  }, []);

  if (!open) return null;

  return <PwaModal open={open} setOpen={setOpen} os={os} />;
};

export default PwaInstallPrompt;
